import { useNavigate, useLocation } from "react-router";
import { useMemo } from "react";
import { PAGE_PARAMETER } from "helpers/constants/miscellaneous";
import { FilterOption } from "types";

const useUpdateQueryParameter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const updateQueryParameter = (
    options: FilterOption[],
    parameter: string,
    field: keyof FilterOption = "text"
  ) => {
    const result = options
      .filter((option) => option.selected === true)
      .map((option) => option[field] as string);

    if (result.length > 0) {
      searchParams.set(parameter, JSON.stringify(result));
    } else {
      searchParams.delete(parameter);
    }
    searchParams.set(PAGE_PARAMETER, "1");
    navigate({ search: `?${searchParams.toString()}` });

    return Object.fromEntries(searchParams.entries());
  };

  return updateQueryParameter;
};

export default useUpdateQueryParameter;
